// extracted by mini-css-extract-plugin
module.exports = {"root":"_2F2eVrS3bkgo"};